/**
 * Keep payoff copy in the client as presentation. Explain benefits rather than repeating row titles; omit
 * durations so users evaluate the benefit before the time cost.
 */
import type { SetupStep, SetupStepId } from "~vue/ProfileSetup/types";

export interface SetupAskCopy {
    payoff: string;
}

export const SETUP_ASK_COPY: Record<SetupStepId, SetupAskCopy> = {
    identity: {
        payoff: "Your title and what you’re working towards, so I stop guessing at both.",
    },
    calendar: {
        payoff: "Who you spend the week with, and where the time goes. This is the one that changes my answers most.",
    },
    perspective: {
        payoff: "How you like to work and be challenged, so I push where it helps and back off where it doesn’t.",
    },
    publish: {
        payoff: "A short read on how to work with you, drawn from the three above. I write it, you edit it, and it stays private until you publish.",
    },
};

/**
 * Use Start/Resume consistently on setup and homepage entry buttons; repeating the next ask's verb makes
 * the entry button look like a duplicate row action.
 */
export function setupCtaLabel(steps: SetupStep[], completedCount: number): string {
    if (steps.every((step) => step.done)) {
        return "";
    }
    return completedCount === 0 ? "Start" : "Resume";
}
